export default {
  height: 'auto',
  calcHeight: 'auto',
  tip: false,
  border: true,
  index: false,
  viewBtn: true,
  selection: false,
  indexLabel: '序号',
  labelWidth: 130,
  addBtn: false,
  menu: false,
  refreshBtn: false,
  columnBtn: false,
  column: [
    {
      label: '费用类型',
      prop: 'costType',
      rules: [
        {
          required: true,
          message: '请选择费用类型',
          trigger: 'change',
        },
      ],
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=cost_type',
      props: { label: 'dictValue', value: 'dictKey' },
    },
    {
      label: '费用名称',
      prop: 'costName',
      rules: [
        {
          required: true,
          message: '请输入费用名称',
          trigger: 'change',
        },
      ],
      maxlength: 15,
      showWordLimit: true,
    },
    {
      label: '计量单位',
      prop: 'unit',
      rules: [
        {
          required: true,
          message: '请选择单位',
          trigger: 'change',
        },
      ],
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=unit',
      props: { label: 'dictValue', value: 'dictKey' },
    },
    {
      label: '价格(元)',
      prop: 'price',
    },
    {
      label: '数量',
      prop: 'num',
    },
    {
      label: '金额',
      prop: 'totalAmount',
    },
    {
      label: '材质',
      prop: 'materials',
      maxlength: 15,
      showWordLimit: true,
    },
    {
      label: '型号',
      prop: 'materialType',
      maxlength: 15,
      showWordLimit: true,
    },
    {
      label: '品牌',
      prop: 'brand',
      maxlength: 15,
      showWordLimit: true,
    },
  ],
};
